<template>

    <div class="d-md-none">
        <a id="hamburger-toggle" href="#" @click.prevent="showMobileMenu = !showMobileMenu">
            <i class="fas fa-bars"></i>
        </a>
        <transition name="dropdown">
            <div v-show="showMobileMenu" id="hamburger-menu">
                <div class="dropdown-menu dropdown-menu-lg">
                    <div class="d-flex justify-content-end"><v-close /></div>
                    <div class="pl-30 pr-30 pb-30">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </transition>
    </div>

</template>

<style lang="scss">

    #hamburger-toggle {
        @include font-semibold(16px);
        align-items: center;
        color: $color-text;
        display: flex;
        height: 40px;
        justify-content: center;
        text-decoration: none;
        transition: color .3s;
        width: 30px;
        &:hover {
            color: $color-primary;
            text-decoration: none;
        }
    }

    #hamburger-menu {
        box-sizing: border-box;
        padding: 10px;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        z-index: 1000;
        .dropdown-menu {
            background: $color-white;
            border: none;
            border-radius: 5px;
            box-shadow: 0 10px 30px rgba(0,0,0,0.3);
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            margin: 0;
            padding: 0;
            position: relative;
            width: 100%;
            .dropdown-item {
                @include font-medium(14px);
                background: none;
                color: $color-text;
                line-height: 30px;
                margin: 0;
                padding: 0;
                text-decoration: none;
                transition: color .3s;
                user-select: none;
                &:hover {
                    color: $color-primary;
                    text-decoration: none;
                }
            }
        }
    }

</style>

<script>

import Close from '@cmp/Close';

export default {

    components: {
        'v-close': Close,
    },

    data() {
        return {
            showMobileMenu: false,
        }
    },

    mounted() {
        document.getElementById('hamburger-menu').addEventListener('click', (e) => {
            this.showMobileMenu = !this.showMobileMenu;
        });
    },

}

</script>
